var _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 3,
    viewBox: "0 0 6 3",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.53906,
    y1: 1.5,
    x2: 4.62199,
    y2: 1.5,
    stroke: "#BDBDBD"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1.26831,
    y1: -1.31134e-8,
    x2: 1.26831,
    y2: 3,
    stroke: "#BDBDBD"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 5.12183,
    y1: -1.70142e-8,
    x2: 5.12183,
    y2: 3,
    stroke: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionBtn);
export default __webpack_public_path__ + "static/media/actionBtn.bbc29430bded327388418145ab2a8d36.svg";
export { ForwardRef as ReactComponent };